<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  avgTimePerStage: {
    type: Object,
    required: true,
  },
});

const hasData = computed(() => {
  return Object.keys(props.avgTimePerStage || {}).length > 0;
});
</script>

<template>
  <div class="p-5 rounded-lg border border-n-weak bg-n-solid-2">
    <div class="flex items-center justify-between mb-5">
      <h3 class="text-sm font-medium text-n-slate-12">
        {{ $t('PIPELINE.DASHBOARD.CHARTS.AVG_TIME_PER_STAGE') }}
      </h3>
    </div>
    <div class="space-y-2">
      <div
        v-for="(days, stage) in avgTimePerStage"
        :key="stage"
        class="flex items-center justify-between p-3 rounded-lg bg-n-alpha-2"
      >
        <div class="flex items-center gap-2">
          <div class="w-1.5 h-1.5 rounded-full bg-n-brand" />
          <span class="text-sm text-n-slate-11">
            {{ stage }}
          </span>
        </div>
        <span class="text-sm font-medium text-n-slate-12">
          {{ days }}
          <span class="text-xs font-normal text-n-slate-11">
            {{ $t('PIPELINE.DASHBOARD.DAYS') }}
          </span>
        </span>
      </div>
      <div
        v-if="!hasData"
        class="flex flex-col items-center justify-center py-12"
      >
        <Icon icon="i-lucide-clock" class="size-10 text-n-slate-9 mb-2" />
        <p class="text-sm text-n-slate-11">
          {{ $t('PIPELINE.DASHBOARD.NO_DATA') }}
        </p>
      </div>
    </div>
  </div>
</template>
